

export const frontMatter = {
	sidebar_position: 1,
	license: 'republish',
	author: 'Jan van Steenbergen',
	description: 'Genders, numbers, cases, declensions and more',
	origin: 'http://steen.free.fr/interslavic/nouns.html'
};
export const contentTitle = 'Іменники';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-i-18-n-uk-docusaurus-plugin-content-docs-current-learn-grammar-nouns-md-944.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const toc = [{
  "value": "Відмінювання іменників чоловічого роду",
  "id": "masculine-declension",
  "level": 2
}, {
  "value": "Відмінювання іменників середнього роду",
  "id": "neuter-declension",
  "level": 2
}, {
  "value": "Відмінювання іменників жіночого роду",
  "id": "feminine-declension",
  "level": 2
}, {
  "value": "Атематичне відмінювання",
  "id": "athematic-declension",
  "level": 2
}, {
  "value": "Неправильні іменники",
  "id": "irregular-nouns",
  "level": 2
}, {
  "value": "Невідмінювані іменники",
  "id": "indeclinable-nouns",
  "level": 2
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    abbr: "abbr",
    code: "code",
    h1: "h1",
    h2: "h2",
    header: "header",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {CustomAfterSection, CustomBeforeSection, MDNouns1, MDNouns2, MDNouns3, MDNouns4, MDNouns5, TransliteratorElement} = _components;
  if (!CustomAfterSection) _missingMdxReference("CustomAfterSection", true);
  if (!CustomBeforeSection) _missingMdxReference("CustomBeforeSection", true);
  if (!MDNouns1) _missingMdxReference("MDNouns1", true);
  if (!MDNouns2) _missingMdxReference("MDNouns2", true);
  if (!MDNouns3) _missingMdxReference("MDNouns3", true);
  if (!MDNouns4) _missingMdxReference("MDNouns4", true);
  if (!MDNouns5) _missingMdxReference("MDNouns5", true);
  if (!TransliteratorElement) _missingMdxReference("TransliteratorElement", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "іменники",
        children: "Іменники"
      })
    }), "\n", _jsx(_components.p, {
      children: "Як і більшість слов’янських мов, іменники в міжслов’янській мові мають три граматичні роди (чоловічий, жіночий, середній), два числа (однина, множина) і сім відмінків (називний, знахідний, родовий, давальний, орудний, місцевий, кличний). Вокатив, який використовується для прямого звернення до особи чи предмета, насправді не є реальним відмінком, оскільки він суттєво відрізняється від інших відмінків: він існує лише в однині іменників чоловічого та жіночого роду, він ніколи не впливає на прикметники чи займенники та має нічого спільного з синтаксичною будовою речення."
    }), "\n", _jsx(_components.p, {
      children: "Слід уникати довгих і складних парадигм, але ми не можемо уникнути розрізнення кількох різних класів слів. В основному міжслов'янська мова має три відміни:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["До першої відміни належать усі іменники чоловічого роду, що закінчуються на приголосний, а також іменники середнього роду, що закінчуються на ", _jsx(TransliteratorElement, {
          children: "-o"
        }), " або ", _jsx(TransliteratorElement, {
          children: "-e"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["До другої відміни належать усі іменники жіночого роду на ", _jsx(TransliteratorElement, {
          children: "-a"
        }), "."]
      }), "\n", _jsx(_components.li, {
        children: "ІІІ відміна всі іменники жіночого роду на приголосний."
      }), "\n", _jsxs(_components.li, {
        children: ["Факультативна четверта („атематична”) відміна обговорюється ", _jsx(_components.a, {
          href: "#athematic-declension",
          children: "нижче"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "У межах першої відміни ми розрізняємо три типи. Ця різниця стосується лише називного, знахідного та кличного:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Одушевлений чоловічий рід (тварини та особи чоловічої статі): знахідний відмінок завжди ідентичний родовому"
      }), "\n", _jsx(_components.li, {
        children: "Неживі відмінки чоловічого роду (всі інші іменники чоловічого роду): знахідний відмінок завжди збігається з називним."
      }), "\n", _jsx(_components.li, {
        children: "Середній рід: називний, знахідний і кличний завжди ідентичні"
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Ще розрізняють моделі твердого та м’якого відмінювання. М’які стебла – це стебла, які закінчуються на ", _jsx(_components.code, {
        children: "š"
      }), ", ", _jsx(_components.code, {
        children: "ž"
      }), ", ", _jsx(_components.code, {
        children: "č"
      }), ", ", _jsx(_components.code, {
        children: "c"
      }), ", ", _jsx(_components.code, {
        children: "j"
      }), ", ", _jsx(TransliteratorElement, {
        children: "lj"
      }), "  або ", _jsx(TransliteratorElement, {
        children: "nj"
      }), ". Як правило, після м’якої основи ", _jsx(TransliteratorElement, {
        children: "-o"
      }), " і ", _jsx(TransliteratorElement, {
        children: "-y"
      }), " закінчення стають ", _jsx(TransliteratorElement, {
        children: "-e"
      }), ", ", _jsx(TransliteratorElement, {
        children: "-ě"
      }), " стає ", _jsx(TransliteratorElement, {
        children: "-i"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Основні закінчення відображені в таблицях нижче. Форми в дужках вживаються після м’яких основ. Нульові закінчення позначені ", _jsx(TransliteratorElement, {
        children: "-Ø"
      }), ":"]
    }), "\n", _jsx(MDNouns1, {}), "\n", _jsx(_components.p, {
      children: "У словнику подано лише рід слів. З цієї причини наведені нижче приклади згруповані за родом, а не за відмінюванням."
    }), "\n", _jsx(_components.h2, {
      id: "masculine-declension",
      children: "Відмінювання іменників чоловічого роду"
    }), "\n", _jsx(CustomBeforeSection, {}), "\n", _jsx(_components.p, {
      children: "Практично всі іменники чоловічого роду закінчуються на приголосний. Загалом, для іменників чоловічого роду існує лише одна модель відмінювання, але слід пам’ятати кілька речей:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "У випадку одушевлених іменників (тварини та особи чоловічої статі) знахідний відмінок завжди збігається з родовим, тоді як у випадку неживих предметів знахідний відмінок збігається з називним."
      }), "\n", _jsxs(_components.li, {
        children: ["Після м'якого приголосного закінчення ", _jsx(TransliteratorElement, {
          children: "-om"
        }), ", ", _jsx(TransliteratorElement, {
          children: "-ov"
        }), "  і ", _jsx(TransliteratorElement, {
          children: "-y"
        }), " змінюються на ", _jsx(TransliteratorElement, {
          children: "-em"
        }), ", ", _jsx(TransliteratorElement, {
          children: "-ev"
        }), ", ", _jsx(TransliteratorElement, {
          children: "-e"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Одушевлені іменники мають закінчення називного відмінка множини ", _jsx(TransliteratorElement, {
          children: "-i"
        }), " замість закінчення ", _jsx(TransliteratorElement, {
          children: "-y"
        }), "/", _jsx(TransliteratorElement, {
          children: "-e"
        }), "  неживих іменників."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Чотири приклади: ", _jsx(TransliteratorElement, {
        children: "brat"
      }), " „брат”, ", _jsx(TransliteratorElement, {
        children: "dom"
      }), " „будинок”, ", _jsx(TransliteratorElement, {
        children: "muž"
      }), " „людина”, ", _jsx(TransliteratorElement, {
        children: "kraj"
      }), " „країна”."]
    }), "\n", _jsx(MDNouns2, {}), "\n", _jsx(_components.p, {
      children: "Примітки:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["Місцевий відмінок однини - це те, де слов'янські мови найбільше відрізняються. Рекомендоване закінчення ", _jsx(TransliteratorElement, {
          children: "-u"
        }), " (тобто те саме, що й давальний), яке в більшості мов зустрічається принаймні в деяких випадках. Крім того, можна використовувати ", _jsx(TransliteratorElement, {
          children: "-ě"
        }), " після твердих приголосних і ", _jsx(TransliteratorElement, {
          children: "-i"
        }), " після м’яких приголосних (наприклад, ", _jsx(TransliteratorElement, {
          children: "bratě"
        }), ", ", _jsx(TransliteratorElement, {
          children: "muži"
        }), ")."]
      }), "\n", _jsxs(_components.li, {
        children: ["У кличному відмінку ", _jsx(_components.code, {
          children: "k"
        }), ", ", _jsx(_components.code, {
          children: "g"
        }), "  і ", _jsx(_components.code, {
          children: "h"
        }), " стають ", _jsx(_components.code, {
          children: "č"
        }), ", ", _jsx(_components.code, {
          children: "ž"
        }), "  і ", _jsx(_components.code, {
          children: "š"
        }), " перед ", _jsx(_components.code, {
          children: "e"
        }), ": ", _jsx(TransliteratorElement, {
          children: "člověk"
        }), " → ", _jsx(TransliteratorElement, {
          children: "člověče"
        }), ", ", _jsx(TransliteratorElement, {
          children: "Bog"
        }), "  → ", _jsx(TransliteratorElement, {
          children: "Bože"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Слова на ", _jsx(TransliteratorElement, {
          children: "-ec"
        }), " мають кличне закінчення ", _jsx(TransliteratorElement, {
          children: "-če"
        }), " замість очікуваного ", _jsx(TransliteratorElement, {
          children: "-cu"
        }), ": ", _jsx(TransliteratorElement, {
          children: "otec"
        }), " → ", _jsx(TransliteratorElement, {
          children: "otče"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Деякі іменники, що закінчуються на твердий приголосний, мають у науковому правописі м’який приголосний, напр. ", _jsx(TransliteratorElement, {
          children: "gosť"
        }), " „гість”, ", _jsx(TransliteratorElement, {
          children: "lěkaŕ"
        }), " „лікар, лікар”. Вони можуть мати як тверде, так і м’яке відмінювання: ", _jsx(_components.abbr, {
          title: "родовий відмінок, множина",
          children: "род.мн."
        }), " ", _jsx(TransliteratorElement, {
          children: "gostov"
        }), "  або ", _jsx(TransliteratorElement, {
          children: "gostev"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Слова на ", _jsx(TransliteratorElement, {
          children: "-anin"
        }), " втрачають морфему ", _jsx(TransliteratorElement, {
          children: "-in-"
        }), " у множині: ", _jsx(_components.abbr, {
          title: "називний відмінок, однина",
          children: "наз.одн."
        }), " ", _jsx(TransliteratorElement, {
          children: "Slovjanin"
        }), ", ", _jsx(_components.abbr, {
          title: "родовий відмінок, однина",
          children: "род.одн."
        }), " ", _jsx(TransliteratorElement, {
          children: "Slovjanina"
        }), ",  але: ", _jsx(_components.abbr, {
          title: "називний відмінок, множина",
          children: "наз.мн."
        }), " ", _jsx(TransliteratorElement, {
          children: "Slovjani"
        }), ", ", _jsx(_components.abbr, {
          title: "родовий відмінок, множина",
          children: "род.мн."
        }), "  ", _jsx(TransliteratorElement, {
          children: "Slovjanov"
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["На ", _jsx(TransliteratorElement, {
          children: "-a"
        }), " є кілька слів, що позначають осіб чоловічої статі, наприклад ", _jsx(TransliteratorElement, {
          children: "sluga"
        }), " «слуга», ", _jsx(TransliteratorElement, {
          children: "kolega"
        }), " «колега», ", _jsx(TransliteratorElement, {
          children: "sudja"
        }), " «суддя» тощо. У множині вони відмінюються як ", _jsx(TransliteratorElement, {
          children: "brat"
        }), " або ", _jsx(TransliteratorElement, {
          children: "muž"
        }), ", але в однині вони дотримуються моделі ", _jsx(_components.a, {
          href: "#feminine-declension",
          children: "другої відміни"
        }), "."]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "neuter-declension",
      children: "Відмінювання іменників середнього роду"
    }), "\n", _jsxs(_components.p, {
      children: ["Іменники середнього роду закінчуються на ", _jsx(TransliteratorElement, {
        children: "-o"
      }), " (тверда основа) або ", _jsx(TransliteratorElement, {
        children: "-e"
      }), " (м’яка основа). За винятком називного/знахідного відмінка та родового відмінка множини, їх флексія ідентична флексії ", _jsx(_components.a, {
        href: "#masculine-declension",
        children: "неживих іменників чоловічого роду"
      }), ". Будь ласка, запиши:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Знахідний відмінок завжди тотожний називному."
      }), "\n", _jsxs(_components.li, {
        children: ["На називний/знахідний відмінок та орудний відмінок однини впливає правило ", _jsxs(_components.a, {
          href: "/uk/learn/phonology#o--e",
          children: [_jsx(_components.code, {
            children: "o"
          }), "/", _jsx(_components.code, {
            children: "e"
          }), " "]
        }), "."]
      }), "\n", _jsxs(_components.li, {
        children: ["Що стосується місцевого відмінка однини, те, що стосується іменників чоловічого роду, стосується і іменників середнього роду: замість ", _jsx(TransliteratorElement, {
          children: "-u"
        }), " також можна писати ", _jsx(TransliteratorElement, {
          children: "-ě"
        }), " після твердого приголосного або ", _jsx(TransliteratorElement, {
          children: "-i"
        }), " після м'якого приголосного."]
      }), "\n", _jsx(_components.li, {
        children: "Іменники середнього роду не мають кличного відмінка, окремого від називного."
      }), "\n", _jsxs(_components.li, {
        children: ["У родовому відмінку множини іменники середнього роду І відміни мають нульове закінчення ", _jsx(TransliteratorElement, {
          children: "-Ø"
        }), ". У випадках, коли це призводить до неможливих груп приголосних, ", _jsx(TransliteratorElement, {
          children: "-e-"
        }), " вставляється перед ", _jsx(TransliteratorElement, {
          children: "-j"
        }), " або після м’якого приголосного, або ", _jsx(TransliteratorElement, {
          children: "-o-"
        }), " між твердими приголосними: ", _jsxs(TransliteratorElement, {
          children: ["okn", _jsx(_components.strong, {
            children: "o"
          })]
        }), " → ", _jsxs(TransliteratorElement, {
          children: ["ok", _jsx(_components.strong, {
            children: "o"
          }), "n"]
        }), ", ", _jsxs(TransliteratorElement, {
          children: ["morj", _jsx(_components.strong, {
            children: "e"
          })]
        }), " → ", _jsxs(TransliteratorElement, {
          children: ["mor", _jsx(_components.strong, {
            children: "e"
          }), "j"]
        }), "."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Існує також особлива група іменників середнього роду із закінченням ", _jsx(TransliteratorElement, {
        children: "-e"
      }), " (у науковій орфографії: ", _jsx(TransliteratorElement, {
        children: "-ę"
      }), "), наприклад ", _jsx(TransliteratorElement, {
        children: "ime"
      }), " „ім’я” (основа: ", _jsx(TransliteratorElement, {
        children: "imen-"
      }), ") і ", _jsx(TransliteratorElement, {
        children: "tele"
      }), " „теля” (основа: ", _jsx(TransliteratorElement, {
        children: "telęt-"
      }), "). Він також містить кілька слів на ", _jsx(TransliteratorElement, {
        children: "-o"
      }), ", наприклад ", _jsx(TransliteratorElement, {
        children: "nebo"
      }), " «небо» (основа: ", _jsx(TransliteratorElement, {
        children: "nebes-"
      }), "). У старослов'янській вони належали до особливої відміни, яка нині зникла в більшості мов. Вони можуть відмінюватися як звичайні іменники середнього роду (так, якби їхні номінативи були ", _jsx(TransliteratorElement, {
        children: "imeno"
      }), " та ", _jsx(TransliteratorElement, {
        children: "teleto"
      }), "), вони також можуть відмінюватися відповідно до більш архаїчного ", _jsx(_components.a, {
        href: "#athematic-declension",
        children: "атематичного відмінювання"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Оскільки ми зазвичай не розрізняємо ", _jsx(_components.code, {
        children: "ę"
      }), " і ", _jsx(_components.code, {
        children: "e"
      }), ", корисно пам’ятати, що іменник із закінченням на ", _jsx(TransliteratorElement, {
        children: "-e"
      }), " завжди є середнім родом, і, як правило, коли цьому ", _jsx(TransliteratorElement, {
        children: "-e"
      }), " передує:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.code, {
          children: "m"
        }), ", тоді корінь ", _jsx(TransliteratorElement, {
          children: "-men-"
        }), ": ", _jsx(TransliteratorElement, {
          children: "ime"
        }), ", род. ", _jsx(TransliteratorElement, {
          children: "imena"
        })]
      }), "\n", _jsxs(_components.li, {
        children: ["твердий приголосний, тоді корінь ", _jsx(TransliteratorElement, {
          children: "-et-"
        }), ": ", _jsx(TransliteratorElement, {
          children: "tele"
        }), ", ", _jsx(_components.abbr, {
          title: "родовий відмінок",
          children: "род."
        }), " ", _jsx(TransliteratorElement, {
          children: "teleta"
        }), "  (іменником цієї групи зазвичай називають дітей або молодих тварин)"]
      }), "\n", _jsxs(_components.li, {
        children: ["м'який приголосний, тоді корінь ", _jsx(TransliteratorElement, {
          children: "-Ø-"
        }), ": ", _jsx(TransliteratorElement, {
          children: "morje"
        }), ", ", _jsx(_components.abbr, {
          title: "множина",
          children: "мн."
        }), " ", _jsx(TransliteratorElement, {
          children: "morja"
        }), "  (іншими словами, іменник ", _jsx(TransliteratorElement, {
          children: "-o"
        }), ", на який поширюється правило o/e)"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Для решти відмінювання завжди правильне. Три приклади: ", _jsx(TransliteratorElement, {
        children: "slovo"
      }), " „слово”, ", _jsx(TransliteratorElement, {
        children: "morje"
      }), " „море”, ", _jsx(TransliteratorElement, {
        children: "ime"
      }), " „назва”."]
    }), "\n", _jsx(MDNouns3, {}), "\n", _jsx(_components.h2, {
      id: "feminine-declension",
      children: "Відмінювання іменників жіночого роду"
    }), "\n", _jsxs(_components.p, {
      children: ["Більшість іменників жіночого роду мають закінчення ", _jsx(TransliteratorElement, {
        children: "-a"
      }), " і тому належать до другої відміни. Знову ж таки, ми розрізняємо тверді та м’які стебла. У випадку іменників жіночого роду різниця між твердим і м’яким відмінюванням полягає не лише в застосуванні правила o/e. Як правило, закінчення ", _jsx(TransliteratorElement, {
        children: "-y"
      }), " і ", _jsx(TransliteratorElement, {
        children: "-ě"
      }), " після твердого приголосного перетворюються на ", _jsx(TransliteratorElement, {
        children: "-e"
      }), " і ", _jsx(TransliteratorElement, {
        children: "-i"
      }), " після м'якого приголосного (іншими словами, вони «перевертаються»)."]
    }), "\n", _jsxs(_components.p, {
      children: ["Як і у випадку з іменниками середнього роду, нульове закінчення в родовому відмінку множини може вимагати вставки епентетичного голосного ", _jsx(TransliteratorElement, {
        children: "-e-"
      }), " або ", _jsx(TransliteratorElement, {
        children: "-o-"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Кілька слів на ", _jsx(TransliteratorElement, {
        children: "-i"
      }), " також належать до цієї групи (наприклад, ", _jsx(TransliteratorElement, {
        children: "pani"
      }), ", яке відмінюється так, якби називний відмінок однини був *", _jsx(TransliteratorElement, {
        children: "panja"
      }), ")."]
    }), "\n", _jsxs(_components.p, {
      children: ["Відміна ", _jsx(TransliteratorElement, {
        children: "-a"
      }), " також включає ряд іменників чоловічого роду із закінченням ", _jsx(TransliteratorElement, {
        children: "-a"
      }), ", які стосуються осіб чоловічої статі, наприклад ", _jsx(TransliteratorElement, {
        children: "sluga"
      }), " „слуга” та ", _jsx(TransliteratorElement, {
        children: "sudja"
      }), " „суддя”. Вони відмінюються як ", _jsx(TransliteratorElement, {
        children: "žena"
      }), " або ", _jsx(TransliteratorElement, {
        children: "zemja"
      }), " в однині, але в множині вони наслідують модель одушевлених іменників чоловічого роду: ", _jsx(_components.abbr, {
        title: "називний відмінок, однина",
        children: "наз.одн."
      }), " ", _jsx(TransliteratorElement, {
        children: "sluga"
      }), ", ", _jsx(_components.abbr, {
        title: "родовий відмінок, однина",
        children: "род.одн."
      }), " ", _jsx(TransliteratorElement, {
        children: "slugy"
      }), ", ", _jsx(_components.abbr, {
        title: "називний відмінок, множина",
        children: "наз.мн."
      }), " ", _jsx(TransliteratorElement, {
        children: "slugi"
      }), ", ", _jsx(_components.abbr, {
        title: "родовий відмінок, множина",
        children: "род.мн."
      }), " ", _jsx(TransliteratorElement, {
        children: "slugov"
      }), ",  тощо."]
    }), "\n", _jsxs(_components.p, {
      children: ["Ще одна група іменників жіночого роду — це ті, що закінчуються на приголосний. Вони утворюють третю відміну. Більшість іменників цієї категорії закінчуються на ", _jsx(TransliteratorElement, {
        children: "-ost"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Приклади: ", _jsx(TransliteratorElement, {
        children: "žena"
      }), " „жінка”, ", _jsx(TransliteratorElement, {
        children: "zemja"
      }), " „земля”, ", _jsx(TransliteratorElement, {
        children: "kost"
      }), " „кістка”."]
    }), "\n", _jsx(MDNouns4, {}), "\n", _jsx(_components.h2, {
      id: "athematic-declension",
      children: "Атематичне відмінювання"
    }), "\n", _jsxs(_components.p, {
      children: ["Крім регулярних відмін, перерахованих вище, старослов’янська мова також мала інший тип відмінювання, так зване ", _jsx(_components.strong, {
        children: "атематичне відмінювання"
      }), ". Іменники цього типу поширювалися різними шляхами в сучасних слов’янських мовах, здебільшого зливаючись в один або декілька звичайних типів відмінювання. Міжслов'янські проекти вибирають різні підходи до цієї групи, але деякі з них зберігають її."]
    }), "\n", _jsx(_components.p, {
      children: "До цього типу відмінювання належать іменники всіх трьох родів, але найбільше серед них іменників середнього роду. Можна виділити наступні підтипи:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["іменники чоловічого роду на ", _jsx(TransliteratorElement, {
          children: "-en"
        }), ", невелика група, включаючи напр. ", _jsx(TransliteratorElement, {
          children: "kamen"
        }), " „камінь” і ", _jsx(TransliteratorElement, {
          children: "koren"
        }), " „корінь”"]
      }), "\n", _jsxs(_components.li, {
        children: ["іменники середнього роду на ", _jsx(TransliteratorElement, {
          children: "-me"
        }), "/", _jsx(TransliteratorElement, {
          children: "-men"
        }), "-, що містять численні іменники, такі як ", _jsx(TransliteratorElement, {
          children: "ime"
        }), " „ім’я”, ", _jsx(TransliteratorElement, {
          children: "rame"
        }), " „плече”, ", _jsx(TransliteratorElement, {
          children: "brěme"
        }), " „тягар”"]
      }), "\n", _jsxs(_components.li, {
        children: ["іменники середнього роду на ", _jsx(TransliteratorElement, {
          children: "-e"
        }), "/", _jsx(TransliteratorElement, {
          children: "-et"
        }), "-, що стосуються дітей і молодих тварин, напр. ", _jsx(TransliteratorElement, {
          children: "tele"
        }), " „теля”, ", _jsx(TransliteratorElement, {
          children: "prase"
        }), " „порося”"]
      }), "\n", _jsxs(_components.li, {
        children: ["іменники середнього роду на ", _jsx(TransliteratorElement, {
          children: "-o"
        }), "/", _jsx(TransliteratorElement, {
          children: "-es"
        }), "-, група лише з кількох слів, напр. ", _jsx(TransliteratorElement, {
          children: "nebo"
        }), " „небо”"]
      }), "\n", _jsxs(_components.li, {
        children: ["іменники жіночого роду на ", _jsx(TransliteratorElement, {
          children: "-ov"
        }), ", напр. ", _jsx(TransliteratorElement, {
          children: "crkov"
        }), " „церква”, ", _jsx(TransliteratorElement, {
          children: "mrkov"
        }), " „морква”"]
      }), "\n", _jsxs(_components.li, {
        children: ["іменники жіночого роду на ", _jsx(TransliteratorElement, {
          children: "-i"
        }), "/", _jsx(TransliteratorElement, {
          children: "-er"
        }), "-, що містять лише два іменники: ", _jsx(TransliteratorElement, {
          children: "mati"
        }), " „мама” та ", _jsx(TransliteratorElement, {
          children: "doči"
        }), " „донька”"]
      }), "\n"]
    }), "\n", _jsx(MDNouns5, {}), "\n", _jsx(_components.p, {
      children: "Цілого атематичного відмінювання можна уникнути, схиляючи ці слова за звичайними відмінюваннями, як це робить більшість інших слов’янських мов. В такому разі:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "kamenj"
        }), " відмінюється як звичайний іменник чоловічого роду (", _jsx(_components.abbr, {
          title: "родовий відмінок",
          children: "род."
        }), " ", _jsx(TransliteratorElement, {
          children: "kamenja"
        }), ", ", _jsx(_components.abbr, {
          title: "давальний відмінок",
          children: "дав."
        }), " ", _jsx(TransliteratorElement, {
          children: "kamenju"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "ime"
        }), " і ", _jsx(TransliteratorElement, {
          children: "tele"
        }), " відмінюються як ", _jsx(TransliteratorElement, {
          children: "slovo"
        }), ", якби їхні номінативи були ", _jsx(TransliteratorElement, {
          children: "imeno"
        }), " і ", _jsx(TransliteratorElement, {
          children: "teleto"
        }), ": ", _jsx(_components.abbr, {
          title: "родовий відмінок",
          children: "род."
        }), " ", _jsx(TransliteratorElement, {
          children: "imena"
        }), ", ", _jsx(TransliteratorElement, {
          children: "teleta"
        }), ", ", _jsx(_components.abbr, {
          title: "давальний відмінок",
          children: "дав."
        }), " ", _jsx(TransliteratorElement, {
          children: "imenu"
        }), ", ", _jsx(TransliteratorElement, {
          children: "teletu"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "nebo"
        }), " також відмінюється як ", _jsx(TransliteratorElement, {
          children: "slovo"
        }), " (", _jsx(_components.abbr, {
          title: "родовий відмінок",
          children: "род."
        }), " ", _jsx(TransliteratorElement, {
          children: "neba"
        }), ", ", _jsx(_components.abbr, {
          title: "давальний відмінок",
          children: "дав."
        }), " ", _jsx(TransliteratorElement, {
          children: "nebu"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "crkov"
        }), " відмінюється як ", _jsx(TransliteratorElement, {
          children: "kost"
        }), " (", _jsx(_components.abbr, {
          title: "родовий відмінок",
          children: "род."
        }), " ", _jsx(TransliteratorElement, {
          children: "crkvi"
        }), "); замість ", _jsx(TransliteratorElement, {
          children: "crkov"
        }), " також можна використовувати форму ", _jsx(TransliteratorElement, {
          children: "crkva"
        }), ", яка відмінюється як ", _jsx(TransliteratorElement, {
          children: "žena"
        }), " (", _jsx(_components.abbr, {
          title: "родовий відмінок",
          children: "род."
        }), " ", _jsx(TransliteratorElement, {
          children: "crkvy"
        }), ", ", _jsx(_components.abbr, {
          title: "давальний відмінок",
          children: "дав."
        }), " ", _jsx(TransliteratorElement, {
          children: "crkvě"
        }), ")"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "mati"
        }), " відмінюється як ", _jsx(TransliteratorElement, {
          children: "kost"
        }), ": ", _jsx(_components.abbr, {
          title: "родовий відмінок",
          children: "род."
        }), "/", _jsx(_components.abbr, {
          title: "давальний відмінок",
          children: "дав."
        }), " ", _jsx(TransliteratorElement, {
          children: "materi"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "irregular-nouns",
      children: "Неправильні іменники"
    }), "\n", _jsxs(_components.p, {
      children: ["Міжслов’янська мова зберігається настільки регулярною, наскільки це можливо, але не можна уникнути кількох випадків нерегулярності, не кидаючи виклик натуралізму. Наступні іменники мають неправильну форму множини (всі чотири відмінюються як іменник жіночого роду типу ", _jsx(TransliteratorElement, {
        children: "kost"
      }), "):"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "člověk"
        }), " (", _jsx(_components.abbr, {
          title: "чоловічий рід",
          children: "ч.р."
        }), ") «людина, особа», ", _jsx(_components.abbr, {
          title: "множина",
          children: "мн."
        }), " ", _jsx(TransliteratorElement, {
          children: "ljudi"
        }), "  «люди»"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "děte"
        }), " (", _jsx(_components.abbr, {
          title: "родовий відмінок",
          children: "род."
        }), " ", _jsx(TransliteratorElement, {
          children: "děteta"
        }), "  або ", _jsx(TransliteratorElement, {
          children: "dětete"
        }), ") (", _jsx(_components.abbr, {
          title: "середній рід",
          children: "с.р."
        }), ") „дитина”, ", _jsx(_components.abbr, {
          title: "множина",
          children: "мн."
        }), " ", _jsx(TransliteratorElement, {
          children: "děti"
        }), "  „діти”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "oko"
        }), " (", _jsx(_components.abbr, {
          title: "середній рід",
          children: "с.р."
        }), ") „око”, ", _jsx(_components.abbr, {
          title: "множина",
          children: "мн."
        }), " ", _jsx(TransliteratorElement, {
          children: "oči"
        }), "  „очі”"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(TransliteratorElement, {
          children: "uho"
        }), " (", _jsx(_components.abbr, {
          title: "середній рід",
          children: "с.р."
        }), ") „вухо”, ", _jsx(_components.abbr, {
          title: "множина",
          children: "мн."
        }), " ", _jsx(TransliteratorElement, {
          children: "uši"
        }), "  „вуха”"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Звичайні множини (", _jsx(TransliteratorElement, {
        children: "člověki"
      }), ", ", _jsx(TransliteratorElement, {
        children: "oka"
      }), "  тощо) також можна використовувати, але деякі з них звучать дуже дивно для слов’янського вуха, хоча вони все одно будуть зрозумілі."]
    }), "\n", _jsx(_components.h2, {
      id: "indeclinable-nouns",
      children: "Невідмінювані іменники"
    }), "\n", _jsxs(_components.p, {
      children: ["Запозичена міжнародна лексика, що закінчується на ", _jsx(TransliteratorElement, {
        children: "-e"
      }), ", ", _jsx(TransliteratorElement, {
        children: "-i"
      }), "  або ", _jsx(TransliteratorElement, {
        children: "-u"
      }), " (наприклад, ", _jsx(TransliteratorElement, {
        children: "alibi"
      }), ", ", _jsx(TransliteratorElement, {
        children: "hobi"
      }), ", ", _jsx(TransliteratorElement, {
        children: "intervju"
      }), ", ", _jsx(TransliteratorElement, {
        children: "kafe"
      }), ", ", _jsx(TransliteratorElement, {
        children: "kakao"
      }), ", ", _jsx(TransliteratorElement, {
        children: "kliše"
      }), ", ", _jsx(TransliteratorElement, {
        children: "menju"
      }), ", ", _jsx(TransliteratorElement, {
        children: "tabu"
      }), ", ", _jsx(TransliteratorElement, {
        children: "taksi"
      }), "), і скорочення не відмінюються. У будь-якому випадку неможливо додати відмінкові закінчення, але в такому випадку найкраще відокремити їх від іменника апострофом: ", _jsx(TransliteratorElement, {
        children: "togo alibi’a"
      }), ", ", _jsx(TransliteratorElement, {
        children: "te intervju’y"
      }), ", ", _jsx(TransliteratorElement, {
        children: "tyh taksi’ov"
      }), ",  тощо."]
    }), "\n", _jsx(CustomAfterSection, {})]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

